import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-atomic": "true",
  "aria-live": "assertive"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Pas de logs à afficher", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]

import { toRefs, ref, onBeforeMount, onBeforeUnmount } from 'vue';

// Personal components
import QDialogTemplate from '@components/template/QDialogTemplate.vue';
import QBtnValid from '@components/form/QBtnValid.vue';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// Personal libs
import { convertDateToLiterral } from '@shared/lib/date.lib';
import { LogEntry } from '@shared/lib/logger/logger.interface';
import bus from '@shared/lib/eventbus.lib';
import { BusEventEnum } from '@shared/enum/bus/bus-events.enum';
import { LoggerLevelEnum } from '@shared/lib/logger/logger.enum';

/**
 * Emits
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogConsole',
  props: {
  show: { type: Boolean, required: true, default: false },
  maxLines: { type: Number, required: false, default: 100 },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

// Vendor
const emits = __emit;

/**
 * ViewModel
 */
const { isMobile } = useGlobalVM();

/**
 * Properties
 */
const props = __props;
const { show, maxLines } = toRefs(props);

/**
 * Reactive datas
 */
const logs = ref<LogEntry[]>([]);

function addLog(log: LogEntry) {
  // Insert the log at the beginning of the list
  logs.value?.splice(0, 0, log);

  // Removes logs to keep up to 100 lines
  if (logs.value.length > maxLines.value) {
    logs.value?.splice(maxLines.value, logs.value.length - maxLines.value);
  }
}

/**
 * Hooks
 */
onBeforeMount(() => {
  bus.on(BusEventEnum.LOGGER_DISPLAY_ENTRY, (log: LogEntry) => {
    addLog(log);
  });
});

onBeforeUnmount(() => {
  bus.off(BusEventEnum.LOGGER_DISPLAY_ENTRY);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QDialogTemplate, {
    title: "Console",
    "show-dialog": _unref(show),
    position: 'bottom',
    seamless: true,
    height: _unref(isMobile) ? 200 : 300,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
  }, {
    header: _withCtx(() => [
      _createVNode(QBtnValid, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (logs.value = [])),
        "icon-left": 'delete_forever',
        title: 'Vider la liste'
      })
    ]),
    content: _withCtx(() => [
      (logs.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (log, index) => {
              return (_openBlock(), _createElementBlock("p", {
                class: "no-margin no-padding text-sm",
                style: {"border-bottom":"1px solid black"},
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(convertDateToLiterral)(new Date(log.timestamp ?? 0), ' à ', true)), 1 /* TEXT */),
                _createTextVNode(" - " + _toDisplayString(_unref(LoggerLevelEnum)[log.level] ?? '') + " - " + _toDisplayString(log.title ?? '') + " " + _toDisplayString(log.message ?? ''), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-dialog", "height"]))
}
}

})